import React from 'react';
import PropTypes from 'prop-types';
import {PUBLIC_URL} from '@/env';

DocsLink.propTypes = {
    icon: PropTypes.node,
};

function DocsLink({icon, ...rest}) {
    return (
        <a href={`${PUBLIC_URL}/docs/`} target="_blank" rel="noreferrer" {...rest}>
            {icon}
            使用文档
        </a>
    );
}

export default DocsLink;
